import { render, staticRenderFns } from "./AppIconDelete.vue?vue&type=template&id=61d72f39&scoped=true&"
import script from "./AppIconDelete.vue?vue&type=script&lang=js&"
export * from "./AppIconDelete.vue?vue&type=script&lang=js&"
import style0 from "./AppIconDelete.vue?vue&type=style&index=0&id=61d72f39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d72f39",
  null
  
)

export default component.exports